// Sales routes (under accounting app)

const routes = [
  {
    path: "/accounting/sales",
    redirect: "/accounting/sales/analytics",
  },
  {
    path: "/accounting/sales/analytics",
    name: "SalesAnalytics",
    component: () => import("@/views/sales/SalesAnalytics.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/visiera-orders",
    name: "VisieraOrders",
    component: () => import("@/views/sales/VisieraOrders.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
];

export default routes;